import '@/playlist/games/laneChooser/styles/lane-chooser-sky.scss';

import React from 'react';

import Cloud1 from '@/playlist/games/laneChooser/assets/images/cloud-1.svg?react';
import Cloud2 from '@/playlist/games/laneChooser/assets/images/cloud-2.svg?react';
import Cloud3 from '@/playlist/games/laneChooser/assets/images/cloud-3.svg?react';
import Cloud4 from '@/playlist/games/laneChooser/assets/images/cloud-4.svg?react';

type Props = { className?: string };

const Sky = ({ className }: Props) => {
	return (
		<div className={className ? className : 'lane-chooser__sky'} aria-hidden>
			<div className="lane-chooser__sun" />
			<Cloud1 className="lane-chooser__cloud lane-chooser__cloud--1" />
			<Cloud2 className="lane-chooser__cloud lane-chooser__cloud--2" />
			<Cloud3 className="lane-chooser__cloud lane-chooser__cloud--3" />
			<Cloud4 className="lane-chooser__cloud lane-chooser__cloud--4" />
		</div>
	);
};

export default Sky;
